import { ICompanyProductionCapacitiesForm } from '../../components/ProductionCapacity/production-capacity.types'
import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import {
  ICompanyProductionCapacityResponse,
  ICompanyProductionResponse,
  ICreateCompanyProductionCapacities,
} from './company-production.types'

export class CompanyProduction extends ServiceBase {
  public async getCompanyProductions(
    id: string,
  ): Promise<ICompanyProductionResponse[]> {
    const url = `/company-production/${id}`

    const response = await this.request.get<
      ICompanyProductionResponse[],
      IError
    >(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getCompanyProductionCapacities(
    id: string,
  ): Promise<ICompanyProductionCapacityResponse[]> {
    const url = `/company-production/capacity/${id}`

    const response = await this.request.get<
      ICompanyProductionCapacityResponse[],
      IError
    >(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async deleteCompanyProductionCapacityCategory(
    companyId: string,
    categoryId: string,
  ): Promise<void> {
    const url = `/company-production/capacity/${companyId}/${categoryId}`

    await this.request.delete<void, IError>(url)

    return
  }

  public async createCompanyProductionCapacities(
    companyId: string,
    data: ICompanyProductionCapacitiesForm,
  ): Promise<void> {
    const url = `/company-production/capacity/${companyId}`

    const body = {
      capacities: data.capacities.map((c) => ({
        capacity: Number(c.capacity),
        finishedItemCategoryId: c.finishedItemCategoryId,
        taxUnit: c.taxUnit,
      })),
    } as ICreateCompanyProductionCapacities

    await this.request.post<ICompanyProductionCapacityResponse[], IError>(
      url,
      body,
    )

    return
  }
}
